/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './Account-Actions';
import initialState from '../../../../initialState';

const accountReducer = (state = initialState.payment.account, action) => {
    switch (action.type) {
        case actions.setAccountMessage().type:
            return {
                ...state,
                accountMessage: action.data,
            };
        default:
            return state;
    }
};

export default accountReducer;
